import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MasterDataService } from '../Services/MasterDataService';
import { BaseResponse, ErrorResponse } from '../Models/ResponseModels';
import * as _ from 'lodash';
import { AppSettings } from './AppSettings';
import { NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import {AuthActionCodes, ModuleLicenceCodes} from '../Models/EnumModels';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { PropertyBasicInfo, GenericMaster } from '../Models/GlobalEntities';

export class BaseComponent {
    public FormErrors: Array<ErrorResponse> = [];
    public IsSubmitting: boolean = false;

    ReturnURL: string = "";
    ReturnURLModel: string = "";
    AppSettings: AppSettings = AppSettings;
    public _AuthActionCodes = AuthActionCodes;

    constructor(public translate: TranslateService, public toastr: ToastrService, public route: ActivatedRoute, public router: Router, public masterService: MasterDataService) {
        this.FormErrors = new Array();
        if (this.route && this.route.data) {
            this.route.data
                .subscribe((data) => {
                    if (data.SelectedModule) {
                        this.masterService.CurrentUIState.SelectedModule = data.SelectedModule;
                        this.masterService.CurrentUIState.SreenName = data.ScreenName;
                    }
                });

        }
        if (this.masterService.ReturnURL != null && this.masterService.ReturnURL != "") {
            this.ReturnURL = _.cloneDeep(this.masterService.ReturnURL);
            this.ReturnURLModel = _.cloneDeep(this.masterService.ReturnURLModel);

            this.masterService.ResetReturnURL();
        }
    }

    public get HasErrors(): boolean {
        if (this.FormErrors == undefined || this.FormErrors == null)
            return false;

        return (this.FormErrors.length > 0);
    }

    ngOnInit(): void {

    }

    SubmitStart(): void {
        this.IsSubmitting = true;
    }

    SubmitEnd(): void {
        this.IsSubmitting = false;
    }

    FromBaseResponse(response: BaseResponse): void {
        if (response == null)
            return;

        this.FormErrors = response.Errors;
    }

    ClearErrors(): void {
        this.FormErrors = [];
    }

    AddError(Msg: string): void {
        let err = new ErrorResponse();
        err.ErrorMessage = Msg;
        this.FormErrors.push(err);
    }

    ShowErrorInPopup(): void {
        let str = "";
        for (let i = 0; i < this.FormErrors.length; i++) {
            let row = this.FormErrors[i];
            let msg = row.ErrorMessage;
            if (row != null && !(/^TS\./.test(msg)) && !(/^ERR\./.test(msg)))
                msg = 'ERR.' + msg;
            str +=  this.translate.instant(msg) + "\n";
        }

        alert(str);
    }

    GetDateForBootstrapControls(dt: Date, time: NgbTimeStruct): Date {
        if (dt == null)
            return null;

        let _dt = _.cloneDeep(dt);

        if (time != null) {
            if (time.hour != null)
                _dt.setHours(time.hour);

            if (time.minute != null)
                _dt.setMinutes(time.minute);
        }

        return _dt;
    }

    SetTimeForBootstrapControls(dt: Date) {
        if (dt == null) {
            return null;
        }
        let _time: NgbTimeStruct = { hour: null, minute: null, second: null };
        _time.hour = moment(dt).seconds();
        _time.minute = moment(dt).minutes();
        _time.hour = moment(dt).hours();
        return _time;
    }

    SetDateForBootstrapControls(dt: Date) {
        if (dt == null) {
            return null;
        }
        //let _date = new Date(dt);
        let _date = moment(dt).format('YYYY-MM-DD');
        return moment(_date, 'YYYY-MM-DD').toDate();
    }

    CheckAuth_Action(Action: string): boolean {
        return this.masterService.CheckAuth_Action(Action);
    }

    CheckAuth_Dept_Action(PropertyId: number, DeptId: number, Action: string): boolean {
        return this.masterService.CheckAuth_Dept_Action(PropertyId, DeptId, Action);
    }

    GetTranslation(Label: string): string {
        let str = this.translate.instant(Label);
        if (str == null)
            return Label;

        return str;
    }

    GetMultilingualToast(msg: string, type: string) {
        if (msg != null && !(/^TS\./.test(msg)) && !(/^ERR\./.test(msg)) && type == 'error')
            msg = 'ERR.' + msg;
        let translatedText = this.translate.instant(msg)
        if (/^ERR\./.test(translatedText))
            translatedText = translatedText.substring(4);
        switch (type) {
            case "success":
                this.toastr.success(translatedText);
                break;
            case "show":
                this.toastr.show(translatedText);
                break;
            case "error":
                this.toastr.error(translatedText);
                break;
            case "info":
                this.toastr.info(translatedText);
                break;
            case "warning":
                this.toastr.warning(translatedText);
                break;
        }
    }

    GetFileExtension(FileName: string): string {
        if (FileName == null)
            return "";

        let idx = FileName.lastIndexOf('.');
        if (idx < 0)
            return "";

        return FileName.substring(idx + 1);
    }

    GetProperties_Action(Action: string): Array<PropertyBasicInfo> {
        return this.masterService.GetProperties_Action(Action);
    }

    GetDepartments_Action(PropertyId: number, Action: string): Array<GenericMaster> {
        return this.masterService.GetDepartments_Action(PropertyId, Action);
    }
    OpenWindow(url: string) {
        window.open(url, '_blank');
    }

    CheckActiveLicence_Module(propertyId: number, module: string): boolean {
        return this.masterService.CheckActiveLicence_Module(propertyId, module);
    }

    CheckAnyActiveLicense_Module(moduleCode: ModuleLicenceCodes): boolean {
        return this.masterService.CheckAnyActiveLicense_Module(moduleCode);
    }
}
